export const mediaContentIsValid = (content) => {
    const textValid = content['media_type'] === 'Text' && content.text?.length;
    const imageValid = content['media_type'] === 'Image' && content.url?.length;
    const videoValid = content['media_type'] === 'Video' && content.url?.length;
    const pdfValid = content['media_type'] === 'PDF' && content.url?.length;

    return textValid || imageValid || videoValid || pdfValid;
};

export const getMediaContentOverallType = (mediaItems) => {
    const existingTypes = mediaItems
        .filter((content) => mediaContentIsValid(content))
        .map((content) => content['media_type'] === 'Text' ? 'Notes' : 'Attachments')
        .filter((type) => type != null)
        .reduce((acc, cur) => ({ ...acc, [cur] : true }), {});

    const uniqueTypes = Object.keys(existingTypes);

    return uniqueTypes.length ? uniqueTypes.join(' and ') : null;
};